<template>
  <div>
    <b-alert
      :show="getNotification.show"
      :variant="getNotification.type"
      dismissible
      class="alert alert-elevate"
      @dismissed="notificationDismissed"
      @dismiss-count-down="countDownNotification"
      >{{ getNotification.message }}</b-alert
    >

    <div class="row">
      <div class="col-md-12">
        <MPortlet
          v-bind="{
            title: pageTitle,
            isLoading: isLoading,
            loadingText: loadingMessage
          }"
        >
          <template v-slot:toolbar>
            <router-link
              :to="{ name: 'admin-roles' }"
              class="btn btn-label-success btn-sm btn-bold"
              >Back</router-link
            >
          </template>
          <template v-slot:body>
            <v-card :flat="true">
              <ValidationObserver
                ref="dataForm"
                v-slot="{ valid, dirty, passes }"
              >
                <v-form @submit.prevent="passes(submit)">
                  <v-container>
                    <v-row dense>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Name"
                          vid="name"
                          rules="required|min:3"
                        >
                          <v-text-field
                            v-model="formData.name"
                            :error-messages="errors"
                            label="Name"
                            required
                            hide-details="auto"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Email Address"
                          vid="email"
                          rules="required|email"
                        >
                          <v-text-field
                            v-model="formData.email"
                            type="email"
                            :error-messages="errors"
                            label="Email Address"
                            required
                            :disabled="recordID > 0"
                            hide-details="auto"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Password"
                          vid="password"
                          :rules="recordID > 0 ? '' : 'required|min:6'"
                        >
                          <v-text-field
                            v-model="formData.password"
                            :error-messages="errors"
                            label="Password"
                            required
                            hide-details="auto"
                            :append-icon="
                              showPassword.password ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showPassword.password ? 'text' : 'password'"
                            hint="At least 6 characters"
                            counter
                            @click:append="
                              showPassword.password = !showPassword.password
                            "
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Confirm Password"
                          vid="password_confirmation"
                          rules="required_if:password|confirmed:password"
                        >
                          <v-text-field
                            v-model="formData.password_confirmation"
                            :error-messages="errors"
                            label="Confirm Password"
                            :required="recordID < 1"
                            hide-details="auto"
                            :append-icon="
                              showPassword.confirm ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showPassword.confirm ? 'text' : 'password'"
                            hint="At least 6 characters"
                            counter
                            @click:append="
                              showPassword.confirm = !showPassword.confirm
                            "
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Role"
                          vid="role"
                          rules="required"
                        >
                          <v-select
                            :items="getRolesItems()"
                            v-model="formData.role_id"
                            :error-messages="errors"
                            label="Role"
                            required
                            hide-details="auto"
                            placeholder="Select Role"
                          ></v-select>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Additional Role(s)"
                          vid="roles"
                        >
                          <v-select
                            :items="getRolesItems(true)"
                            v-model="formData.roles"
                            :error-messages="errors"
                            label="Additional Role(s)"
                            hide-details="auto"
                            multiple
                            placeholder="Additional Roles"
                          ></v-select>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="sm" lg="4" md="6" sm="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Status"
                          vid="status"
                          rules="required|numeric"
                        >
                          <v-select
                            :items="statusItems"
                            v-model="formData.status"
                            :error-messages="errors"
                            label="Status"
                            required
                            hide-details="auto"
                            placeholder="Select Status"
                          ></v-select>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6" sm="12">
                        <v-row>
                          <v-col cols="6" lg="4">
                            <b-button
                              variant="primary"
                              class="btn-block"
                              @click="submit"
                              :disabled="!valid"
                              >Save</b-button
                            >
                          </v-col>
                          <v-col cols="6" lg="4">
                            <b-button
                              variant="danger"
                              class="btn-block"
                              @click="cancel(dirty)"
                              >Cancel</b-button
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </ValidationObserver>
            </v-card>
          </template>
        </MPortlet>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from "@/common/api.service";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import {
  required,
  required_if,
  email,
  confirmed,
  min,
  numeric
} from "vee-validate/dist/rules";

import { ALERT_TYPES } from "@/consts";

import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import MPortlet from "@/views/partials/content/MPortlet.vue";

setInteractionMode("eager");

extend("email", email);
extend("numeric", numeric);

extend("min", {
  ...min,
  message: "{_field_} must be at least {length} characters"
});

extend("confirmed", {
  ...confirmed,
  message: "Password does not match"
});

extend("required", {
  ...required,
  message: "{_field_} can not be empty"
});

extend("required_if", {
  ...required_if,
  message: "{_field_} can not be empty"
});

export default {
  name: "UserForm",
  components: {
    MPortlet,
    ValidationProvider,
    ValidationObserver
  },
  metaInfo: vm => {
    return {
      title: vm.pageTitle
    };
  },
  data() {
    return {
      showPassword: {
        password: false,
        confirm: false
      },
      recordID: 0,
      storeNamespace: "adminUsers",
      statusItems: [
        {
          text: "Enable",
          value: 1
        },
        {
          text: "Disable",
          value: 0
        }
      ],
      roles: [],
      formData: {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        avatar: "",
        status: "",
        role_id: 0,
        roles: []
      }
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.recordID = this.$route.params.id;
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Users", route: "users" },
      { title: this.pageTitle }
    ]);

    this.loadRoles();

    if (this.recordID > 0) {
      if (this.getActiveRecord && this.getActiveRecord.id) {
        this.initEdit(this.getActiveRecord, this.getActiveRecord.roles || []);
      } else {
        this.setLoading(true);

        this.$store
          .dispatch(this.addNamespace("getRecord"), this.recordID)
          .then(response => {
            this.initEdit(response.data, response.data.roles || []);
          })
          .catch(() => {
            this.$router.push({ name: "admin-404" });
          })
          .then(() => {
            this.setLoading(false);
          });
      }
    }
  },
  computed: {
    ...mapGetters("adminUsers", ["isLoading", "getErrors", "getActiveRecord"]),
    getNotification: {
      get() {
        return this.notification;
      },
      deep: true
    },
    pageTitle() {
      return `${this.isEdit ? "Edit" : "New"} User`;
    }
  },
  methods: {
    loadRoles() {
      let self = this;

      this.setLoading(true, "loading roles...");

      ApiService.query("admin/roles", { per_page: "all" })
        .then(function(response) {
          self.roles = response.data.data;
        })
        .catch(function(error) {
          self.showNotification(error.message, ALERT_TYPES.danger, false, 5);
        })
        .then(function() {
          self.setLoading(false);
        });
    },
    getRolesItems(additional) {
      var items = [];

      this.roles.map(role => {
        if (additional && role.id == this.formData.role_id) {
          var idx = this.formData.roles.indexOf(role.id);

          if (idx > -1) {
            this.formData.roles.splice(idx, 1);
          }

          return;
        }

        items.push({
          text: role.display_name,
          value: role.id
        });
      });

      return items;
    },
    submit() {
      var self = this;

      this.setLoading(true, "Saving...");

      var recordAction =
        this.recordID > 0
          ? this.$store.dispatch(this.addNamespace("updateRecord"), {
              form_data: this.formData,
              recordId: this.recordID
            })
          : this.$store.dispatch(this.addNamespace("addRecord"), {
              form_data: this.formData,
              commitData: false
            });

      recordAction
        .then(response => {
          if (response.success) {
            this.$alert({
              title: "Success!",
              message: response.message
            }).$on("confirmed", () => {
              self.$router.push({ name: "admin-users" });
            });
          }
        })
        .catch(error => {
          self.$scrollToTop();

          if (error.data && error.data.errors) {
            self.$refs.dataForm.setErrors(error.data.errors);
          } else {
            self.showNotification(
              "Operation Error! please check your input and try again",
              ALERT_TYPES.Danger,
              false,
              5
            );
          }
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    cancel(isDirty) {
      if (
        isDirty &&
        !confirm("Your input will lost, do you want to continue?")
      ) {
        return;
      }

      this.$refs.dataForm.reset();

      this.$router.push({ name: "admin-users" });
    },
    initEdit(record, roles) {
      this.formData.name = record.name;
      this.formData.email = record.email;
      this.formData.status = record.status;
      this.formData.avatar = record.avatar.indexOf("default")
        ? null
        : record.avatar_link;
      this.formData.role_id = record.role_id;

      if (roles.length) {
        roles.map(role => {
          this.formData.roles.push(role.id);
        });
      }
    }
  }
};
</script>
